import React, { useContext, useState } from "react";
import "./auth.scss";
import bg from "../../img/bgg.jpg";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { AuthContext } from "../../context/AuthContext";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const { dispatch } = useContext(AuthContext);

  const loginAccount = async (e) => {
    e.preventDefault();
    dispatch({ type: "LOGIN_START" });

    try {
      setLoading(true);
      const response = await axios.post(
        `/login-admin`,
        {
          email,
          password,
        },
        { withCredentials: true },
      );

      if (response.data.success) {
        dispatch({
          type: "LOGIN_SUCCESS",
          payload: response.data.user,
          token: response.data.accessToken,
        });
        navigate("/event");
      } else {
        dispatch({ type: "LOGIN_FAILURE", payload: "Invalid credentials" });
        setErrorMsg("Incorrect password. Please try again.");
      }
    } catch (error) {
      dispatch({
        type: "LOGIN_FAILURE",
        payload:
          error.response?.data?.message || "Login failed. Please try again.",
      });
      setErrorMsg("Login failed. Please check your credentials.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="auth_wrp"
      style={{
        backgroundImage: `linear-gradient(90deg, rgba(2, 0, 36, 0.65) 0%, rgba(9, 9, 121, 0.4) 35%, rgba(0, 212, 255, 0) 100%), url(${bg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        height: "95dvh",
      }}
    >
      <div className="card-wrapper">
        <div
          style={{
            display: "flex",
            alignItems: "center",
            width: "100%",
            justifyContent: "center",
          }}
        >
          <h5>
            Admin <em>Login</em>
          </h5>
        </div>
        <form className="activation-form" onSubmit={loginAccount}>
          {/* Event Section */}
          <section
            className="input-group"
            style={{ gap: "20px", display: "flex", flexDirection: "column" }}
          >
            <input
              type="text"
              value={email}
              placeholder="user@email.com"
              onChange={(e) => setEmail(e.target.value)}
            />
            <input
              type="password"
              value={password}
              placeholder="*******"
              onChange={(e) => setPassword(e.target.value)}
            />
          </section>
          <button className="btn-submit">Login</button>
        </form>
      </div>
    </div>
  );
};

export default Login;
